import type { FlowDefinition } from '@tutlo/contracts'
import { defaultFlow } from './default.ts'
import { testFlow } from './test-flow.ts'

/** Rejestr kwalifikatorów per slug (`/q/:slug`). Nowa wersja ścieżki = nowy plik + wpis tutaj. */
export const flows: Readonly<Record<string, FlowDefinition>> = {
  [defaultFlow.slug]: defaultFlow,
  [testFlow.slug]: testFlow,
}

export function getFlow(slug: string): FlowDefinition | null {
  return flows[slug] ?? null
}

export type { FlowState } from './engine.ts'
export {
  answer,
  currentQuestion,
  FLOW_END,
  isDone,
  progress,
  questionKind,
  resume,
  start,
} from './engine.ts'
export { answersSummary } from './summary.ts'
export { defaultFlow, testFlow }
